import { render } from "./EditAccessory.vue?vue&type=template&id=ad7f0cf8"
import script from "./EditAccessory.vue?vue&type=script&lang=js"
export * from "./EditAccessory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__